module.exports = __webpack_public_path__ + "img/blue.d2bdae7a.svg";